import { CeruleanButton, WhiteBlueButton } from 'components/Button'
import Column from 'components/Column'
import I18n from 'components/I18n'
import iconColor from 'components/iconColor'
import InputContainer from 'components/InputContainer'
import FasCheck from 'components/Legacy/Icons/FasCheck'
import FasShieldAlt from 'components/Legacy/Icons/FasShieldAlt'
import Text from 'components/Text'
import messages from 'lang'
import React from 'react'
import styled from 'styled-components'
import { color, px, screenWidth } from 'utils'

import { PropsType as _P } from './template'

const Wrapper = styled(Column)`
  position: relative;
  width: 100%;
  padding: 2rem;
  flex-flow: wrap;

  > * {
    flex: 1 0 100%;
  }

  @media only screen and (max-width: ${screenWidth('sm')}) {
    padding: 1.5rem;
  }
`
const HeaderWrapper = styled(Column)`
  position: relative;
  width: 100%;
`
const FooterWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 2rem;

  & > button {
    width: 46%;
  }
`
const Title = styled(Text)`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  text-align: center;
`
const SubWrapper = styled.div`
  display: flex;
  margin-bottom: 2.5rem;
  text-align: left;

  @media only screen and (max-width: ${screenWidth('xs')}) {
    margin-bottom: 2.75rem;
  }
`
const ShieldIcon = styled(FasShieldAlt)`
  ${iconColor('blue600')};
  margin-bottom: 2rem;
`
const GreenCheckWrapper = styled.div`
  height: 24px;
  width: 24px;
  background-color: ${color('green400')};
  border-radius: 12px;
`
const Check = styled(FasCheck)`
  ${iconColor('white')};
  margin: 4px 3px 3px 4px;
`
const Row = styled.div`
  display: flex;
  align-items: center;

  &:not(:last-child) {
    margin-bottom: 1rem;
  }
`
const BulletText = styled(Text)`
  margin-left: 1.5rem;
  line-height: 22px;
  font-size: 14px;
`
const CancelButton = styled(WhiteBlueButton)`
  border: 1px solid ${color('grey100')};
`

type PropsType = _P

const Setup = ({ hideModal }: PropsType) => (
  <Wrapper>
    <HeaderWrapper>
      <ShieldIcon size={px(1.75)} />
      <Title color='white' size='xl' weight={600}>
        <I18n data={messages.title_setup_whitelist} />
      </Title>
      <SubWrapper>
        <Text color='grey400' weight={500}>
          <I18n data={messages.sub_title_setup_whitelist} />
        </Text>
      </SubWrapper>
    </HeaderWrapper>
    <Column>
      <InputContainer>
        <Row>
          <GreenCheckWrapper>
            <Check size={px(1)} />
          </GreenCheckWrapper>
          <BulletText color='grey400' weight={500}>
            <I18n data={messages.whitelisting_setup_point} />
          </BulletText>
        </Row>
        <Row>
          <GreenCheckWrapper>
            <Check size={px(1)} />
          </GreenCheckWrapper>
          <BulletText color='grey400' weight={500}>
            <I18n data={messages.whitelisting_setup_point2} />
          </BulletText>
        </Row>
      </InputContainer>
      <FooterWrapper>
        <CancelButton e2e='cancelButton' onClick={() => hideModal('ENABLE_WHITELIST_ADDRESS')}>
          <I18n data={messages.button_cancel} />
        </CancelButton>
        <CeruleanButton e2e='nextButton' type='submit'>
          <I18n data={messages.whitelisting_enable} />
        </CeruleanButton>
      </FooterWrapper>
    </Column>
  </Wrapper>
)

export default Setup
